import axios from "axios";

// Constants
import constants from "@/constants";

const instance = axios.create({
    baseURL: constants.breakoutApiBaseUrl,
    headers: {
        Authorization: `Bearer ${constants.breakoutApiToken}`,
        "Content-Type": "application/json",
    },
});

export default instance;
